<div style="margin-top: 10px" class="contrainer-fluid p-3">
    <!--  -->
    <div class="row justify-content-center mt-4">
        <div id="stage-parent" class="p-0" [style.width.px]="stage.width()" [style.height.px]="stage.height()">
            <div id="container" (click)="click($event)" style="border: 1px solid black;"></div>
        </div>
    </div>

    <!-- <div fxShow fxHide.gt-sm class="row justify-content-center p-3" *ngIf="Model.RequiredActions && Model.RequiredActions.length > 1">
  <button class="col mx-3" mat-raised-button color="accent" (click)="showWarningsAboutSimulationType()">
    <mat-icon class="m-auto">information</mat-icon>
    <span class="m-auto">Avertissement</span>
  </button>
</div> -->

    <div class="row justify-content-center align-self-center p-2">
        <div class="col-auto">

            <button class="h-100" mat-raised-button color="primary" (click)="addWindArrow()" [disabled]="!canAddWindArrow()">
                <span> Sens du Vent</span>
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        <div class="col-auto me-5">

            <button class="m-auto" mat-mini-fab color="warn" (click)="deleteWindArrow()" [disabled]="canAddWindArrow()">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>
        </div>

        <div class="col-auto">

            <button class="h-100" mat-raised-button color="primary" (click)="addMoveArrow()" [disabled]="!canAddMoveArrow()">
                <span> Zone de travail</span>
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        <div class="col-auto me-5">

            <button class="" mat-mini-fab color="warn" (click)="deleteMoveArrow()" [disabled]="canAddMoveArrow()">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>
        </div>

        <div class="col-auto ms-5">

            <button appPreventDoubleClick class="h-100" mat-raised-button color="primary" (throttledClick)="saveMap()" [disabled]="!CanSave">
                <mat-icon class="material-symbols-outlined">save</mat-icon>
                <span class="ml-2">Sauvegarder</span>
            </button>
        </div>
    </div>

    <!-- <div class="row  p-1">
        <mat-form-field class="col">
            <mat-label>Commentaire</mat-label>
            <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" #comment matInput placeholder="Commentaire" [(ngModel)]="Model.Comment"
                      [formControl]="ValidMaxLegnth"></textarea>
            <mat-hint align="end">{{comment.value.length || 0}}/{{MAX_LENGTH}}</mat-hint>
            @if (ValidMaxLegnth.hasError('maxlength')) {
            <mat-error>
                Text is too long
            </mat-error>
            }
        </mat-form-field>
    </div> -->

    <!-- <div class="row mt-4 justify-content-center">

    </div> -->
</div>